import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminLayout from './layouts/Admin';
import CustomerLayout from './layouts/Customer';
import Landing from './views/Landing';
import Login from './views/auth/Login';
import Register from './views/auth/Register';
import ForgotPassword from './views/auth/ForgotPassword';
import ResetPassword from './views/auth/ResetPassword';

function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-spinner">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={`/${user.role}`} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-spinner">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={`/${user.role}`} replace />;
}

function ImpersonationBanner() {
  const email = localStorage.getItem('impersonatingEmail');
  const adminToken = localStorage.getItem('adminToken');

  React.useEffect(() => {
    const active = !!(email && adminToken);
    document.body.classList.toggle('has-impersonation-banner', active);
    return () => document.body.classList.remove('has-impersonation-banner');
  }, [email, adminToken]);

  if (!email || !adminToken) return null;

  function returnToAdmin() {
    const adminRefreshToken = localStorage.getItem('adminRefreshToken');
    localStorage.setItem('token', adminToken);
    if (adminRefreshToken) localStorage.setItem('refreshToken', adminRefreshToken);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminRefreshToken');
    localStorage.removeItem('impersonatingEmail');
    window.location.assign('/admin/users');
  }

  return (
    <div className="impersonation-banner">
      <span>Impersonating <strong>{email}</strong> for support.</span>
      <button onClick={returnToAdmin} className="impersonation-banner-btn">
        Return to admin
      </button>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ImpersonationBanner />
      <Routes>
        <Route path="/"                 element={<Landing />} />
        <Route path="/login"            element={<Login />} />
        <Route path="/register"         element={<Register />} />
        <Route path="/forgot-password"  element={<ForgotPassword />} />
        <Route path="/reset-password"   element={<ResetPassword />} />
        <Route path="/admin/*"  element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminLayout />
          </ProtectedRoute>
        } />
        <Route path="/customer/*" element={
          <ProtectedRoute allowedRoles={['customer', 'admin']}>
            <CustomerLayout />
          </ProtectedRoute>
        } />
        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </AuthProvider>
  );
}
